import { createContext } from 'react';

import type { CurrentUser } from '@/api/types';
import type { LoginPayload } from './api/authApi';

export interface AuthContextValue {
  user: CurrentUser | null;
  isAuthenticated: boolean;
  /** True only during the initial session-restore. Guards must wait for it. */
  isRestoring: boolean;
  login: (payload: LoginPayload) => Promise<void>;
  logout: () => Promise<void>;
  refreshUser: () => Promise<void>;
}

/**
 * Lives apart from AuthProvider so that file exports only a component, which
 * is what React Fast Refresh needs to hot-reload it rather than remounting the
 * whole tree — and remounting the provider means losing the session on every
 * save.
 */
export const AuthContext = createContext<AuthContextValue | null>(null);
